import { useEffect, useState } from "react";

const DISCORD_WIDGET_URL =
  "https://discord.com/api/guilds/1127671080660766832/widget.json";

function toPublicWidgetData(data) {
  const presenceCount = data?.presence_count;

  if (!Number.isInteger(presenceCount) || presenceCount < 0) {
    return null;
  }

  return {
    presenceCount,
    // Keep only the public fields needed for the optional team-presence display.
    members: Array.isArray(data.members)
      ? data.members
          .filter((member) => typeof member?.username === "string")
          .map(({ username, status }) => ({ username, status }))
      : [],
  };
}

export function useDiscordWidget() {
  const [widget, setWidget] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    let isMounted = true;

    async function loadWidget() {
      try {
        const response = await fetch(DISCORD_WIDGET_URL, {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Discord widget request failed");
        }

        const data = toPublicWidgetData(await response.json());

        if (isMounted && data) {
          setWidget(data);
        }
      } catch (error) {
        // The widget is optional, so the site stays clean when it is unavailable.
        if (error.name !== "AbortError" && isMounted) {
          setWidget(null);
        }
      }
    }

    loadWidget();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return widget;
}
